import { NewPageItem } from "../../../../domain/document/items";
import { AbstractObjectStyleReader } from ".";
import { PaintStyle } from "../../../../domain/drawing";
import {
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";

export class NewPageObjectStyleReader extends AbstractObjectStyleReader<NewPageItem> {
  constructor() {
    super();
  }

  protected readSpecifiedPaintStyle(source: NewPageItem): PaintStyle {
    return null;
  }

  protected readBackgroundColorConfiguration(source: NewPageItem): IBackgroundColorConfiguration {
    return null;
  }

  protected readBorderColorConfiguration(source: NewPageItem): IBorderColorConfiguration {
    return null;
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return {
      isEnable: true,
    };
  }
}
